export default __webpack_public_path__ + "static/media/2002-AMcover.fb61ef3c.png";